import { Box } from "@mui/material";
import GroupSection from "./facet-search-section/FacetSearchSection";
// import { useEasierTheme } from "datalign-themes";
import SearchBar from "../navigation/search-bar";
import { useEffect, useState } from "react";
import SolrService from "services/SolrService";
import { FacetFields } from "models/facet-fields";
import { capitalize } from "lodash";
import InfoSectionService from "services/InfoSectionService";
import InfoSection from "datalign-module-template/models/info-sections";
import InfoSections from "datalign-module-template/components/info-sections";
import AnalyticsService from "services/AnalyticsService";

const { infoSectionsService } = new InfoSectionService();
const { solrService } = new SolrService();
const analyticsService = new AnalyticsService();

const IndexLandingPage = () => {
  const [facets, setFacets] = useState<FacetFields>({});
  const [infoSections, setInfoSections] = useState<InfoSection[]>();

  useEffect(() => {
    infoSectionsService.list().then((resp) => {
      setInfoSections(resp);
    });
  }, []);

  useEffect(() => {
    solrService.facets<FacetFields>().then((resp) => {
      setFacets(resp ?? {});
    });
  }, []);

  useEffect(() => {
    analyticsService.send();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "80%", xl: "70%" },
        }}
      >
        <Box display="flex" flexDirection="column" sx={{ width: "100%" }} p={2}>
          <SearchBar forceDefault={true} facets={facets} />
        </Box>
        <Box p={2}>
          <InfoSections infoSections={infoSections} />
          {facets &&
            Object.keys(facets).length > 0 &&
            Object.keys(facets).map((facet) =>
              facet && facets[facet] && facets[facet].length > 0 ? (
                <GroupSection
                  key={`facet-${facet}`}
                  title={capitalize(facet)}
                  type={facet}
                  facets={facets[facet]}
                />
              ) : (
                <></>
              ),
            )}
        </Box>
      </Box>
    </Box>
  );
};

export default IndexLandingPage;
